import React, { useState } from 'react';

const VariablesForm = ({ variables, initialValues = {}, onSubmit }) => {
    const [formValues, setFormValues] = useState(initialValues);
    const [errors, setErrors] = useState({});

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validar campos requeridos
        const newErrors = {};
        Object.entries(variables).forEach(([key, config]) => {
            if (config.required && !formValues[key]) {
                newErrors[key] = 'Este campo es requerido';
            }
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        onSubmit(formValues);
    };

    const handleChange = (name, value) => {
        setFormValues(prev => ({
            ...prev,
            [name]: value
        }));

        // Limpiar error cuando el usuario empieza a escribir
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: undefined
            }));
        }
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {Object.entries(variables).map(([name, config]) => (
                <div key={name} className="space-y-2">
                    <label
                        htmlFor={name}
                        className="block text-sm font-medium text-gray-700"
                    >
                        {config.description}
                        {config.required && <span className="text-red-500">*</span>}
                    </label>

                    {config.type === 'string' && (
                        <input
                            type="text"
                            id={name}
                            value={formValues[name] || ''}
                            onChange={(e) => handleChange(name, e.target.value)}
                            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm
                                ${errors[name] ? 'border-red-500' : ''}`}
                        />
                    )}

                    {config.type === 'number' && (
                        <input
                            type="number"
                            id={name}
                            value={formValues[name] || ''}
                            onChange={(e) => handleChange(name, e.target.value)}
                            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm
                                ${errors[name] ? 'border-red-500' : ''}`}
                        />
                    )}

                    {errors[name] && (
                        <p className="mt-1 text-sm text-red-500">{errors[name]}</p>
                    )}
                </div>
            ))}

            <div className="pt-4">
                <button
                    type="submit"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Generar Post
                </button>
            </div>
        </form>
    );
};

export default VariablesForm; 